class EventCountdown extends HTMLElement {
    constructor() {
        super();
        this.interval = null;
        this.days = this.querySelector('.days');
        this.hours = this.querySelector('.hours');
        this.minutes = this.querySelector('.minutes');
        this.seconds = this.querySelector('.seconds');
    }
    
    connectedCallback() {
        this.startTimer();
    }
    
    disconnectedCallback() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
    
    attributeChangedCallback() {
        this.startTimer();
    }
    
    startTimer() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        
        const targetDate = this.getAttribute('target-date');
        if (!targetDate) return;
        
        this.targetTime = new Date(targetDate).getTime();
        this.updateDisplay();
        
        this.interval = setInterval(() => {
            this.updateDisplay();
        }, 1000);
    }
    
    updateDisplay() {
        const now = new Date().getTime();
        const timeLeft = this.targetTime - now;
        
        if (timeLeft <= 0) {
            return;
        }
        
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        
        this.days.textContent = String(days).padStart(2, '0');
        this.hours.textContent = String(hours).padStart(2, '0');
        this.minutes.textContent = String(minutes).padStart(2, '0');
        this.seconds.textContent = String(seconds).padStart(2, '0');
    }
}

customElements.define('event-countdown', EventCountdown);